import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Filter from 'rp-react-common/Filter';
import { without, uniq, keys, toLower } from 'lodash';
import FilteringComponent from '../../shared/filter';
import { selection } from '../../utils/filter';
import HeaderRow from './HeaderRow';
import columns from './columns';
import { formatRaceName } from '../../utils/name';
import { areAllFieldsEmpty } from '../../utils/object';
import categoriesFactory from './categories';
import categoriesReducer from './reducer';

const noDataText = 'No favourites records available in the Racing Post database for this year.';

class Favourites extends FilteringComponent {
    constructor(props) {
        super(props);

        const { favourites, profile, seasonDefaults } = this.props.data;
        const { courseCountryCode, courseTypeCode } = profile;
        const { seasonRaceType } = seasonDefaults;

        this.dataKey = 'favourites';
        this.emptyData = { handicap: {}, nonHandicap: {} };

        this.state = {
            categories: categoriesFactory(
                seasonRaceType, courseCountryCode, courseTypeCode
            ),
            data: favourites || this.emptyData,
            loading: false,
            fetchError: false,
        };
    }

    renderStatus() {
        const { categories } = this.state;
        const raceType = selection.getCaption(categories, 'raceType');

        const { value, label } = selection.getOption(categories, 'timePeriod');

        if (value.match(/last5/)) {
            return <h2 className="ui-filter__statusText">{raceType}, {toLower(label)}</h2>;
        }

        const years = uniq(value.split('/').slice(0, 2));
        return <h2 className="ui-filter__statusText">{raceType}, {years.join('-')}</h2>;
    }

    render() {
        const { categories, data: { handicap, nonHandicap }, loading, fetchError } = this.state;

        const isEmptyTable = areAllFieldsEmpty(handicap) || areAllFieldsEmpty(nonHandicap);
        // merging "handicap" and "nonHandicap" objects into one array
        const data = keys(handicap).map(key => ({
            // key of object is the raceName
            raceName: formatRaceName(key),
            // handicap key-values is used without changing
            ...handicap[key],
            // for non-handicap keys added preffix "nh_"
            // to avoid key duplication
            nh_percentage: nonHandicap[key].percentage,
            nh_wins: nonHandicap[key].wins,
            nh_runs: nonHandicap[key].runs,
            nh_stake: nonHandicap[key].stake,
        }));

        // extract total row from array
        const total = isEmptyTable ? null : data.find(({ raceName }) => raceName === 'TOTAL');
        const tableData = isEmptyTable ? null : without(data, total);

        return (
            <section className="cp-favourites">
                <Filter
                    categories={categories}
                    categoriesReducer={categoriesReducer}
                    fetchError={fetchError}
                    onFilterApply={this.onFilterApply}
                />
                {!fetchError && (
                    <RpTable
                        data={tableData}
                        footerData={total}
                        columns={columns}
                        initialSortIdx={0}
                        sortable
                        className="cp-favouritesTable"
                        headerRow={HeaderRow}
                        loading={loading}
                        noDataText={noDataText}
                    />
                )}
            </section>
        );
    }
}

// shape of handicap and non-handicap objects
const itemPropsShape = PropTypes.shape({
    percentage: PropTypes.number,
    runs: PropTypes.number.isRequired,
    stake: PropTypes.number.isRequired,
    wins: PropTypes.number.isRequired,
});

Favourites.propTypes = {
    data: PropTypes.shape({
        favourites: PropTypes.shape({
            handicap: PropTypes.objectOf(itemPropsShape),
            nonHandicap: PropTypes.objectOf(itemPropsShape),
        }),
        profile: PropTypes.shape({
            courseTypeCode: PropTypes.string.isRequired,
            courseCountryCode: PropTypes.string.isRequired,
        }),
        seasonDefaults: PropTypes.shape({
            seasonRaceType: PropTypes.string.isRequired,
        }),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default Favourites;



// WEBPACK FOOTER //
// ./src/js/course/favourites/Favourites.jsx